import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  twitterCard?: string;
}
const SEO = ({
  title,
  description,
  canonicalUrl,
  keywords = 'SmartSoda, showroom experience, premium beverages, customer experience, car dealership, furniture showroom, retail experience',
  ogImage = 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
  ogType = 'website',
  twitterCard = 'summary_large_image'
}: SEOProps) => {
  // Ensure title is not too long (Google typically displays first 50-60 characters)
  const metaTitle = title.length > 60 ? `${title.substring(0, 57)}...` : title;
  // Ensure description is not too long (Google typically displays ~155-160 characters)
  const metaDescription = description.length > 160 ? `${description.substring(0, 157)}...` : description;
  return <Helmet data-id="element-654">
      {/* Basic Meta Tags */}
      <title data-id="element-655">{metaTitle}</title>
      <meta name="description" content={metaDescription} data-id="element-656" />
      <meta name="keywords" content={keywords} data-id="element-657" />
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} data-id="element-658" />}
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-659" />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} data-id="element-660" />}
      <meta property="og:title" content={metaTitle} data-id="element-661" />
      <meta property="og:description" content={metaDescription} data-id="element-662" />
      <meta property="og:image" content={ogImage} data-id="element-663" />
      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} data-id="element-664" />
      <meta name="twitter:title" content={metaTitle} data-id="element-665" />
      <meta name="twitter:description" content={metaDescription} data-id="element-666" />
      <meta name="twitter:image" content={ogImage} data-id="element-667" />
      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" data-id="element-668" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" data-id="element-669" />
      <meta name="robots" content="index, follow" data-id="element-670" />
    </Helmet>;
};
export default SEO;